import { useModalContext } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'

import { useGetMergedJobSeekerQuery } from '../../api'
import { useSelectJobSeeker } from '../../hooks/useGetMergedJobseekerQuery'
import { JobSeekerInfo, JobSeekerInfoContainer } from './RegisterModal'

import {
    RoundedModal,
    RoundedModalContent,
    RoundedModalHeader,
    RoundedModalBody,
    RoundedModalFooter,
    ModalOverlay,
    ModalCloseButton,
    ModalButton,
} from '@/components/Elements'
import { useDashboard, useDashboardDispatch } from '@/features/dashboard'

export const ConfirmModal = () => {
    const { modal, next, sfId } = useDashboard()
    const dispatch = useDashboardDispatch()
    return (
        <RoundedModal
            size="lg"
            isOpen={modal === 'confirm'}
            onClose={() =>
                dispatch({ type: 'CONFIRM', payload: { sfId: '', next: '' } })
            }
        >
            <ModalOverlay />
            <RoundedModalContent>
                <RoundedModalHeader>
                    候補者を {sfId} 様に切り替えます
                </RoundedModalHeader>
                <Content sfId={sfId} next={next} />
            </RoundedModalContent>
        </RoundedModal>
    )
}

const Content = ({ sfId, next }) => {
    const { currentData } = useGetMergedJobSeekerQuery(sfId)
    const { onClose } = useModalContext()
    const navigate = useNavigate()
    const selectJobSeeker = useSelectJobSeeker()
    return (
        <>
            <RoundedModalBody>
                {/* 求職者情報の表示 */}
                <JobSeekerInfoContainer>
                    <JobSeekerInfo data={currentData} />
                </JobSeekerInfoContainer>
            </RoundedModalBody>
            <RoundedModalFooter>
                <ModalCloseButton />
                <ModalButton
                    variant="gradient"
                    isDisabled={!currentData}
                    onClick={async () => {
                        await selectJobSeeker({
                            detail: currentData,
                            distributedAt: currentData.distributedAt,
                        })
                        onClose()
                        navigate(next)
                    }}
                >
                    変更して移動
                </ModalButton>
            </RoundedModalFooter>
        </>
    )
}
Content.propTypes = {
    sfId: PropTypes.string.isRequired,
    next: PropTypes.string.isRequired,
}
